import { Directive, Input } from '@angular/core';
import { UserModel } from '../../user.model';
import { DataFieldModel } from '@fi-app/data-field/data-field.model';
import { DataFieldHelperService } from '@fi-app/data-field/data-field-helper.service';

@Directive()
export class FiUserViewProfileTabBase {
    @Input() user: UserModel;
    @Input() userDataFields: DataFieldModel[];

    constructor(protected dataFieldHelperService: DataFieldHelperService) {}

    getMatIconClass(dataField: DataFieldModel): string {
        return this.dataFieldHelperService.getProfileViewDataFieldsMatIconClass(dataField);
    }

    isUserDataFieldShown(dataField: DataFieldModel): boolean {
        return this.dataFieldHelperService.isUserDataFieldShownIfProfileView(dataField, this.user);
    }
}
